import '../vendor';

import '../general/ofi';
import './event-list/popup';
import './event-list/calendar';
import './event-list/show-filter';
import './event-list/toggle-button';




// WEBPACK FOOTER //
// ./src/js/pages/event-list.js